<template>

<CrearUsuario></CrearUsuario>

</template>


<script>

import CrearUsuario from '../../components/SeguimientoUfinal.vue';

export default {


 components:{

     CrearUsuario

  }

}


</script>